/**
 * @module
 *
 * @import {Local} from '@acng/frontend-relativity';
 * @import {Movie} from '../model/movie';
 */

import {Context, localValue} from '@acng/frontend-relativity';

/**
 * @type {Local<Movie>}
 */
export const ctxMovie = Context();

/**
 * Get the {@link ctxMovie | local movie}.
 *
 * @type {(element: Element) => Movie}
 */
export const getMovie = (element) => localValue(element, ctxMovie);
